import { useState } from "react";
import { useEffect } from "react";
import { motion, useInView } from "framer-motion";
import ReactTooltip from "react-tooltip";

import { MainPageWrap } from "../../wrapper";
import { client, urlFor } from "../../client";

import "./Skills.scss";
import { Fragment } from "react";
import { useRef } from "react";
import { sectionVariants } from "../../utils/animation";

const Skills = ({ handleActiveIndex }) => {
  const [tooltip, showTooltip] = useState(true);
  const [skills, setSkills] = useState([]);
  const [experiences, setExperiences] = useState([]);
  const skillsRef = useRef();
  const isInView = useInView(skillsRef);

  useEffect(() => {
    if (isInView) {
      handleActiveIndex(3);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInView]);

  const iconVariants = {
    out: {
      opacity: 0,
    },
    in: {
      opacity: 1,
    },
  };

  const fetchSkills = async (skillsQuery) => {
    try {
      const response = await client.fetch(skillsQuery);
      const data = await response;
      setSkills(data);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchExperiences = async (experiencesQuery) => {
    try {
      const response = await client.fetch(experiencesQuery);
      const data = await response;
      setExperiences(data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const skillsQuery = '*[_type == "skills"]';
    const experienceQuery = '*[_type == "experiences"]';

    fetchSkills(skillsQuery);
    fetchExperiences(experienceQuery);
  }, []);

  return (
    <motion.div
      ref={skillsRef}
      initial="hidden"
      whileInView="visible"
      variants={sectionVariants}
      viewport={{ once: true }}
      className="skills"
    >
      <h2 className="skills__title title">Skills &#38; Experiences</h2>
      <div className="skills__content">
        <motion.div
          initial="out"
          whileInView="in"
          transition={{
            duration: 0.3,
            staggerChildren: 0.3,
          }}
          viewport={{ once: true }}
          className="skills__list list"
        >
          {skills.map((skill) => {
            const { _id, bgColor, icon, name } = skill;

            return (
              <motion.div
                key={_id}
                className="list__item"
                variants={iconVariants}
              >
                <div
                  className="list__image"
                  style={{ backgroundColor: bgColor }}
                >
                  <img src={urlFor(icon)} alt={name} />
                </div>
                <p className="p-text">{name}</p>
              </motion.div>
            );
          })}
        </motion.div>
        <div className="skills__experiences">
          {experiences.map((experience) => {
            const { _id, year, works } = experience;

            return (
              <motion.div key={_id} className="skills__experience experience">
                <div className="experience__year">
                  <p>{year}</p>
                </div>
                <div className="experience__works">
                  {works.map((work) => {
                    const { name, desc, company } = work;

                    return (
                      <Fragment key={name}>
                        <motion.div
                          className="experience__work"
                          whileInView={{ opacity: [0, 1] }}
                          transition={{ duration: 0.5 }}
                          data-tip
                          data-for={company}
                          onMouseEnter={() => showTooltip(true)}
                          onMouseLeave={() => {
                            showTooltip(false);
                            setTimeout(() => showTooltip(true), 100);
                          }}
                        >
                          <h3>{name}</h3>
                          <p className="p-text">{company}</p>
                        </motion.div>
                        {tooltip && (
                          <ReactTooltip
                            id={company}
                            effect="solid"
                            place="top"
                            type="light"
                            class="experience__tooltip"
                          >
                            {desc}
                          </ReactTooltip>
                        )}
                      </Fragment>
                    );
                  })}
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </motion.div>
  );
};

export default MainPageWrap(Skills, "skills", "white-bg");
